import Head from 'expo-router/head'

import { usePostPaymentOnboardingContext } from './PostPaymentOnboardingContext'
import { PostPaymentOnboardingDetailsStep } from './PostPaymentOnboardingDetailsStep'
import { PostPaymentOnboardingIntroStep } from './PostPaymentOnboardingIntroStep'

export function PostPaymentOnboardingStepContent() {
  const { state, pageTitle } = usePostPaymentOnboardingContext()
  const { step } = state

  if (step === 'intro') {
    return (
      <>
        <Head>
          <title>{pageTitle}</title>
        </Head>
        <PostPaymentOnboardingIntroStep />
      </>
    )
  }

  return (
    <>
      <Head>
        <title>{pageTitle}</title>
      </Head>
      <PostPaymentOnboardingDetailsStep />
    </>
  )
}
